/*------------------------------------*\
    MODULES
\*------------------------------------*/
import Dropdown from 'bootstrap/js/dist/dropdown';

/*------------------------------------*\
    DROPDOWN
\*------------------------------------*/
class DropdownMenu {
    constructor(passedElement) {
        let self = this;

        self.elem = passedElement;
    }

    init() {
        let self = this;
    }
}

export default DropdownMenu;
